<template>
  <div class="projects">
    <b-container class="bv-example-row">
      <div class="projects-header">
        <h1>
          Projects
        </h1>
        <p data-aos="zoom-in-up">
          An idea is just a thought in our heads, that may or may not
          <span class="keywords">come true</span>, But for me when an idea hits
          my head I make everything count, even the smallest detail of it and I
          have been able to carry them out through software development.
          <br />
          <span class="keywords"> I am always open to new ideas</span>, these
          are some that came true.
        </p>
      </div>
      <div class="projects-header">
        <div class="tecnologies-languages">
          <b-row>
            <b-col cols="12">
              <div class="projects-container">
                <h3>
                  <b-img
                    :src="commerceLogo"
                    fluid
                    alt="Commerc-e Logo"
                    class="project-logo"
                  ></b-img>
                  Commerc-e
                </h3>
                <div class="development-tech-project">
                  <h5 class="title-tecnologies">
                    Try it!
                    <a href="https://commerc-e.netlify.app/" target="_blank"
                      >Commerc-e</a
                    >
                  </h5>
                  <div
                    class="tecnologies-stack-container"
                    data-aos="zoom-in-down"
                  >
                    <h4 class="title-tecnologies">Technologies</h4>
                    <span class="tecnologies-projetcs commerc-e">
                      React
                      <b-img :src="reactImage" fluid alt="React Image"></b-img>
                    </span>

                    <span class="tecnologies-projetcs commerc-e">
                      TypeScript
                      <b-img
                        :src="tsImage"
                        fluid
                        alt="TypeScript Image"
                      ></b-img>
                    </span>
                    <span class="tecnologies-projetcs commerc-e">
                      Redux
                      <b-img :src="reduxImage" fluid alt="Redux Image"></b-img>
                    </span>
                    <br />
                    <span class="tecnologies-projetcs commerc-e">
                      Ruby on Rails
                      <b-img
                        :src="rubyOnRailsImage"
                        fluid
                        alt="Ruby on Rails Image"
                      ></b-img>
                    </span>
                    <span class="tecnologies-projetcs commerc-e">
                      MySQL
                      <b-img
                        :src="mySqlImage"
                        fluid
                        alt="Commerc-e Image"
                      ></b-img>
                    </span>
                  </div>
                  <h3 class="social-icon-contanier" data-aos="zoom-in-down">
                    <h5 class="title-info">
                      More Information
                      <a
                        href="https://github.com/sevillecarlos/commerc-e"
                        target="_blank"
                      >
                        <b-icon
                          class="social-icon-projects"
                          icon="github"
                          aria-hidden="true"
                        ></b-icon>
                      </a>
                    </h5>
                  </h3>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="projects-container">
                <h3>
                  <b-img
                    :src="musicRecommendationLogo"
                    fluid
                    alt="Music Recommendation Logo"
                    class="project-logo"
                  ></b-img>

                  Music Recommendation
                </h3>

                <div class="development-tech-project">
                  <h4 class="title-tecnologies">
                    Try it!
                    <a
                      href="https://music-recommendation.netlify.app/"
                      target="_blank"
                      >Music Recommendation</a
                    >
                  </h4>
                  <div
                    class="tecnologies-stack-container"
                    data-aos="zoom-in-down"
                  >
                    <h4 class="title-tecnologies">Technologies</h4>

                    <span class="tecnologies-projetcs ">
                      Vue
                      <b-img :src="vueImage" fluid alt="Vue Image"></b-img>
                    </span>

                    <span class="tecnologies-projetcs music-recommendation">
                      JavaScript
                      <b-img
                        :src="jsImage"
                        fluid
                        alt="TypeScript Image"
                      ></b-img>
                    </span>
                    <span class="tecnologies-projetcs music-recommendation">
                      Vuex
                      <b-img :src="vueImage" fluid alt="Redux Image"></b-img>
                    </span>
                    <br />
                    <span class="tecnologies-projetcs music-recommendation">
                      NodeJs
                      <b-img
                        :src="expressImage"
                        fluid
                        alt="Commerc-e Image"
                      ></b-img>
                    </span>
                    <span class="tecnologies-projetcs music-recommendation">
                      MongoDB
                      <b-img
                        :src="mongodbImage"
                        fluid
                        alt="Ruby on Rails Image"
                      ></b-img>
                    </span>
                  </div>
                </div>

                <h3 class="social-icon-contanier" data-aos="zoom-in-down">
                  <h5 class="title-info">
                    More Information
                    <a
                      href="https://github.com/sevillecarlos/music-recommendation"
                      target="_blank"
                    >
                      <b-icon
                        class="social-icon-projects"
                        icon="github"
                        aria-hidden="true"
                      ></b-icon>
                    </a>
                  </h5>
                </h3>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="projects-container">
                <h3>
                  <b-img
                    :src="medicalMASLogo"
                    fluid
                    alt="Medical MAS Logo"
                    class="project-logo"
                  ></b-img>

                  Medical MAS
                </h3>

                <div class="development-tech-project">
                  <h4 class="title-tecnologies">
                    Try it!
                    <a href="https://medical-mas.netlify.app/" target="_blank"
                      >Medical MAS</a
                    >
                  </h4>
                  <div
                    data-aos="zoom-in-down"
                    class="tecnologies-stack-container"
                  >
                    <h4 class="title-tecnologies">Technologies</h4>

                    <span class="tecnologies-projetcs commerc-e">
                      React
                      <b-img :src="reactImage" fluid alt="React Image"></b-img>
                    </span>

                    <span class="tecnologies-projetcs commerc-e">
                      TypeScript
                      <b-img
                        :src="tsImage"
                        fluid
                        alt="TypeScript Image"
                      ></b-img>
                    </span>
                    <span class="tecnologies-projetcs commerc-e">
                      Redux
                      <b-img :src="reduxImage" fluid alt="Redux Image"></b-img>
                    </span>
                    <br />
                    <span class="tecnologies-projetcs commerc-e">
                      Ruby on Rails
                      <b-img
                        :src="rubyOnRailsImage"
                        fluid
                        alt="Ruby on Rails Image"
                      ></b-img>
                    </span>
                    <span class="tecnologies-projetcs commerc-e">
                      MySQL
                      <b-img
                        :src="mySqlImage"
                        fluid
                        alt="Commerc-e Image"
                      ></b-img>
                    </span>
                  </div>
                </div>

                <h3 class="social-icon-contanier" data-aos="zoom-in-down">
                  <h5 class="title-info">
                    More Information
                    <a
                      href="https://github.com/sevillecarlos/medical-mas"
                      target="_blank"
                    >
                      <b-icon
                        class="social-icon-projects"
                        icon="github"
                        aria-hidden="true"
                      ></b-icon>
                    </a>
                  </h5>
                </h3>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="projects-container">
                <h3>
                  <b-img
                    :src="typingRaceLogo"
                    fluid
                    alt="Typing Race Logo"
                    class="project-logo"
                  ></b-img>
                  Typing Race
                </h3>

                <div class="development-tech-project">
                  <h4 class="title-tecnologies">
                    Try it!
                    <a
                      href="https://typing-race-app.netlify.app/"
                      target="_blank"
                      >Typing Race</a
                    >
                  </h4>
                  <div
                    class="tecnologies-stack-container"
                    data-aos="zoom-in-down"
                  >
                    <h4 class="title-tecnologies">Tecnologies</h4>
                    <span class="tecnologies-projetcs music-recommendation">
                      Vue
                      <b-img :src="vueImage" fluid alt="Vue Image"></b-img>
                    </span>

                    <span class="tecnologies-projetcs music-recommendation">
                      JavaScript
                      <b-img
                        :src="jsImage"
                        fluid
                        alt="TypeScript Image"
                      ></b-img>
                    </span>
                    <span class="tecnologies-projetcs music-recommendation">
                      Vuex
                      <b-img :src="vueImage" fluid alt="Redux Image"></b-img>
                    </span>
                    <br />
                    <span class="tecnologies-projetcs music-recommendation">
                      NodeJs
                      <b-img
                        :src="expressImage"
                        fluid
                        alt="Commerc-e Image"
                      ></b-img>
                    </span>

                    <span class="tecnologies-projetcs music-recommendation">
                      MongoDB
                      <b-img
                        :src="mongodbImage"
                        fluid
                        alt="Ruby on Rails Image"
                      ></b-img>
                    </span>
                  </div>
                </div>
                <h3 class="social-icon-contanier" data-aos="zoom-in-down">
                  <h5 class="title-info">
                    More Information
                    <a
                      href="https://github.com/sevillecarlos/typing-race"
                      target="_blank"
                    >
                      <b-icon
                        class="social-icon-projects"
                        icon="github"
                        aria-hidden="true"
                      ></b-icon>
                    </a>
                  </h5>
                </h3>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="projects-container">
                <h3>
                  <b-img
                    :src="slotMachineLogo"
                    fluid
                    alt="Slot Machine Logo"
                    class="project-logo slot-machine-logo"
                  ></b-img>
                  Slot Machine
                </h3>

                <div class="development-tech-project">
                  <h4 class="title-tecnologies">
                    Try it!
                    <a
                      href="https://slot-machine-app.netlify.app/"
                      target="_blank"
                      >Slot Machine</a
                    >
                  </h4>
                  <div
                    class="tecnologies-stack-container"
                    data-aos="zoom-in-down"
                  >
                    <h4 class="title-tecnologies">Technologies</h4>
                    <span class="tecnologies-projetcs music-recommendation">
                      React
                      <b-img :src="reactImage" fluid alt="Vue Image"></b-img>
                    </span>

                    <span class="tecnologies-projetcs music-recommendation">
                      TypeScript
                      <b-img
                        :src="tsImage"
                        fluid
                        alt="TypeScript Image"
                      ></b-img>
                    </span>
                  </div>
                </div>
                <h3 class="social-icon-contanier" data-aos="zoom-in-down">
                  <h5 class="title-info">
                    More Information
                    <a
                      href="https://github.com/sevillecarlos/slot-machine"
                      target="_blank"
                    >
                      <b-icon
                        class="social-icon-projects"
                        icon="github"
                        aria-hidden="true"
                      ></b-icon>
                    </a>
                  </h5>
                </h3>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="projects-container">
                <h3>
                  <b-img
                    :src="clockLogo"
                    fluid
                    alt="Music Recommendation Logo"
                    class="project-logo"
                  ></b-img>
                  Clock
                </h3>

                <div class="development-tech-project">
                  <h4 class="title-tecnologies">
                    Try it!
                    <a
                      href="https://clock-alarm-timer.netlify.app/"
                      target="_blank"
                      >Clock</a
                    >
                  </h4>
                  <div
                    class="tecnologies-stack-container"
                    data-aos="zoom-in-down"
                  >
                    <h4 class="title-tecnologies">Technologies</h4>
                    <span class="tecnologies-projetcs music-recommendation">
                      React
                      <b-img :src="reactImage" fluid alt="Vue Image"></b-img>
                    </span>

                    <span class="tecnologies-projetcs music-recommendation">
                      JavaScript
                      <b-img
                        :src="jsImage"
                        fluid
                        alt="TypeScript Image"
                      ></b-img>
                    </span>
                  </div>
                  <h3 class="social-icon-contanier" data-aos="zoom-in-down">
                    <h5 class="title-info">
                      More Information
                      <a
                        href="https://github.com/sevillecarlos/clock"
                        target="_blank"
                      >
                        <b-icon
                          class="social-icon-projects"
                          icon="github"
                          aria-hidden="true"
                        ></b-icon>
                      </a>
                    </h5>
                  </h3>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="projects-container">
                <h3>
                  <b-img
                    :src="imposibleHangmanLogo"
                    fluid
                    alt="Imposible Hangman Logo"
                    class="project-logo"
                  ></b-img>
                  Imposible Hangman
                </h3>

                <div class="development-tech-project">
                  <h4 class="title-tecnologies">
                    Try it!
                    <a
                      href="https://imposiblehangman.netlify.app/"
                      target="_blank"
                      >Imposible Hangman</a
                    >
                  </h4>

                  <div
                    class="tecnologies-stack-container"
                    data-aos="zoom-in-down"
                  >
                    <h4 class="title-tecnologies">Technologies</h4>
                    <span class="tecnologies-projetcs music-recommendation">
                      HTML
                      <b-img :src="htmlLogo" fluid alt="HTML Image"></b-img>
                    </span>
                    <span class="tecnologies-projetcs music-recommendation">
                      CSS
                      <b-img :src="cssLogo" fluid alt="CSS Image"></b-img>
                    </span>

                    <span class="tecnologies-projetcs music-recommendation">
                      JavaScript
                      <b-img
                        :src="jsImage"
                        fluid
                        alt="TypeScript Image"
                      ></b-img>
                    </span>
                  </div>
                </div>
                <h3 class="social-icon-contanier" data-aos="zoom-in-down">
                  <h5 class="title-info">
                    More Information
                    <a
                      href="https://github.com/sevillecarlos/imposible-hang-man"
                      target="_blank"
                    >
                      <b-icon
                        class="social-icon-projects"
                        icon="github"
                        aria-hidden="true"
                      ></b-icon>
                    </a>
                  </h5>
                </h3>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
//projects-logos
import commerceLogo from "../assets/projects-logos/commerc-e-logo.png";
import musicRecommendationLogo from "../assets/projects-logos/music-recommendation-logo.png";
import clockLogo from "../assets/projects-logos/clock-logo.png";
import typingRaceLogo from "../assets/projects-logos/typing-race-logo.png";
import imposibleHangmanLogo from "../assets/projects-logos/imposible-hangman-logo.png";
import medicalMASLogo from "../assets/projects-logos/medical-mas-image.png";
import slotMachineLogo from "../assets/projects-logos/slot-machine-logo.png";

//programming languages images
import jsLogo from "../assets/tecnologies-logos/js-logo.png";
import rubyLogo from "../assets/tecnologies-logos/ruby-logo.png";
import tsLogo from "../assets/tecnologies-logos/ts-logo.png";
import pythonLogo from "../assets/tecnologies-logos/python-logo.png";
import cppLogo from "../assets/tecnologies-logos/c++logo.png";
import htmlLogo from "../assets/tecnologies-logos/html-logo.png";
import cssLogo from "../assets/tecnologies-logos/css-logo.png";

//front-end framework images
import reactLogo from "../assets/tecnologies-logos/react-logo.png";
import vueLogo from "../assets/tecnologies-logos/vue-logo.png";
import reduxLogo from "../assets/tecnologies-logos/redux-logo.png";
//back-end framework images
import expressLogo from "../assets/tecnologies-logos/express-nodejs-logo.png";
import rubyOnRailsLogo from "../assets/tecnologies-logos/rubyonrails-logo.png";
//databaseframework images
import mongodbLogo from "../assets/tecnologies-logos/mongodb-logo.png";
import mySqlLogo from "../assets/tecnologies-logos/mysql-logo.png";
export default {
  data() {
    return {
      //projects logos
      commerceLogo: commerceLogo,
      musicRecommendationLogo: musicRecommendationLogo,
      clockLogo: clockLogo,
      typingRaceLogo: typingRaceLogo,
      imposibleHangmanLogo: imposibleHangmanLogo,
      medicalMASLogo: medicalMASLogo,
      slotMachineLogo: slotMachineLogo,
      //programming language logo
      jsImage: jsLogo,
      rubyImage: rubyLogo,
      tsImage: tsLogo,
      pythonImage: pythonLogo,
      cppImage: cppLogo,
      htmlLogo: htmlLogo,
      cssLogo: cssLogo,
      //front-end framework images
      reactImage: reactLogo,
      vueImage: vueLogo,
      reduxImage: reduxLogo,
      //back-end framework images
      expressImage: expressLogo,
      rubyOnRailsImage: rubyOnRailsLogo,
      //database images
      mongodbImage: mongodbLogo,
      mySqlImage: mySqlLogo,
    };
  },
};
</script>

<style>
.projects-header {
  padding: 1%;
}

.projects-header h1 {
  color: #ffbb00 !important;
  font-size: 4vw !important;
  text-shadow: 4px 4px #000000;
  letter-spacing: 1px;
  font-weight: bold;
  padding: 5px;
}
.projects-header h2 {
  color: #ffbb00 !important;
  text-shadow: 3px 3px #000000;
  text-align: left;
  font-size: 3vw;
  font-weight: bolder;
  padding: 5px;
}
.projects-header h3 {
  color: #ffbb00 !important;
  text-shadow: 3px 3px #000000;
  text-align: left;
  font-size: 2vw;
  font-weight: bolder;
  padding: 5px;
}
.projects-header p {
  color: #a8a9ad !important;
  text-shadow: 3px 3px #000000;
  text-align: left;
  font-size: 2vw;
  font-weight: bolder;
  padding: 5px;
}

.development-tech-project span {
  border-radius: 30px;
  font-size: 1.6vw;
  border: 2px solid rgb(19, 18, 18);
  padding: 0.5%;
  color: #a8a9ad !important;
  text-shadow: 3px 3px #000000;
  margin-left: 5%;
  font-weight: bold;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.89);
  -webkit-box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.89);
  -moz-box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.89);
}
.development-tech-project img {
  width: 2.6vw !important;
  margin-bottom: 5px;
  padding: 5px;
}
.project-logo {
  width: 3vw;
}
.projects-container {
  text-align: center;
  padding: 3% !important;
}
.projects-container h3 {
  font-size: 3vw;
  text-align: center;
}
.title-tecnologies {
  text-align: left !important;
  font-size: 1.7vw !important;
  color: #ffbb00 !important;
  font-weight: bold;
}
.title-info {
  font-weight: bold;
}
.title-tecnologies a {
  text-decoration: none;
  color: #a8a9ad !important;
}
.title-tecnologies a:hover {
  color: #393b44 !important;
}
.social-icon-projects {
  color: #a8a9ad !important;
  transition: 0.3s color;
  font-size: 4vw;
  padding: 6px;
  text-align: right !important;
}
.social-icon-projects:hover {
  color: #ffbb00 !important;
}
.social-icon-contanier {
  float: right;
}
.title-info {
  font-size: 1.3vw !important;
}
.slot-machine-logo {
  width: 6vw !important;
}
/*****************************************************/
@media only screen and (max-width: 1032px) {
  .projects-header h1 {
    font-size: 5vw !important;
  }
  .projects-header p {
    font-size: 3vw;
  }

  .title-tecnologies {
    font-size: 3vw !important;
  }
  .projects-container {
    text-align: center;
  }

  .projects-container h3 {
    font-size: 4.5vw !important;
  }
  .development-tech-project span {
    font-size: 2vw;
  }
  .development-tech-project img {
    width: 3.5vw !important;
  }
  .project-logo {
    width: 5vw;
  }

  .social-icon-projects {
    font-size: 6vw;
  }
  .title-info {
    font-size: 3vw !important;
  }
  .slot-machine-logo {
    width: 10vw !important;
  }
}

/* Small phones to small tablets: from 481 to 767*/
@media only screen and (max-width: 767px) {
  .projects-header h1 {
    font-size: 6vw !important;
  }
  .projects-header p {
    font-size: 4vw;
  }

  .title-tecnologies {
    font-size: 5vw !important;
  }
  .projects-container {
    text-align: center;
  }

  .projects-container h3 {
    font-size: 6vw !important;
  }
  .development-tech-project span {
    font-size: 3vw;
    padding: 3px;
  }
  .development-tech-project img {
    width: 6vw !important;
  }
  .slot-machine-logo {
    width: 6vw !important;
  }
  .project-logo {
    width: 6vw;
  }
  .slot-machine-logo {
    width: 12vw !important;
  }
  .social-icon-projects {
    font-size: 10vw;
  }
  .title-info {
    font-size: 4vw !important;
  }
}

/*Small Phone from 0 to 480px*/
@media only screen and (max-width: 400px) {
  .projects-header h1 {
    font-size: 6vw !important;
  }
  .projects-header p {
    font-size: 4vw;
  }

  .title-tecnologies {
    font-size: 5vw !important;
  }
  .projects-container {
    text-align: center;
  }

  .projects-container h3 {
    font-size: 6vw !important;
  }
  .development-tech-project span {
    font-size: 3vw;
    padding: 3px;
  }
  .development-tech-project img {
    width: 6vw !important;
  }
  .slot-machine-logo {
    width: 12vw !important;
  }
  .project-logo {
    width: 6vw;
  }

  .social-icon-projects {
    font-size: 10vw;
  }
  .title-info {
    font-size: 4vw !important;
  }
}
</style>
